@if (isLoading){
  <section class="loading">
    <p-skeleton width="14rem" height="2.5rem" />
    <p-skeleton height="8rem" />
  </section>
} @else {
  <form [formGroup]="formGroup">

    @if ((mode === 'create' || mode === 'edit') && conditionsForm.controls.length > 0) {
      <div class="create">
        <app-button-icon [label]="'common.actions.add-alarm-rule-condition' | translateSafe"
                         [isTranslated]="true"
                         iconName="add"
                         (click)="createConditionOnClick()" />
      </div>
    }

    @if (conditionsForm.controls.length) {
      <div class="condition-grid"
           [class.single]="conditionsForm.length === 1"
           formArrayName="conditions"
           cdkDropList
           (cdkDropListDropped)="dropCondition($event)">
        @for (condition of conditionsForm.controls; track $index; let i = $index) {
          @if (i !== 0) {
            <div
              class="logic">
              <button
                type="button"
                class="logic-button"
                [disabled]="!(mode === 'create' || mode === 'edit')"
                (click)="toggleOperator(i)">
                {{ getOperator(i) }}
              </button>
            </div>
          }

          <div class="card" [formGroupName]="i"
               [style.--indent-level]="getIndentLevel(i)"
               [cdkDragDisabled]="conditionsForm.length <= 1 && (mode === 'create' || mode === 'edit')"
               cdkDrag
               cdkDragPreviewContainer="parent">

            @if (conditionsForm.length !== 1) {
              <div class="drag-handle" cdkDragHandle>
                <span class="material-symbols-rounded">drag_indicator</span>
              </div>
            }

            <div class="content">
              <span class="title">
                <span class="material-symbols-rounded upload-icon">
                  {{ getIcon(i) }}
                </span>
                {{ getName(i) | translateSafe }}
              </span>

              @if (getConditionType(i); as conditionType) {
                @if (getDefinition(conditionType); as definition) {
                  <ng-container
                    *ngComponentOutlet="
                      definition.getEditorComponent();
                      inputs: {
                        formGroup: condition,
                        mode: mode ==  'create' ? 'edit' : mode,
                        condition: getCondition(i)
                      }
                    ">
                  </ng-container>
                }
              }
            </div>

            @if (mode === 'create' || mode === 'edit') {
              <div class="action">
                <app-button-icon
                  class="red"
                  iconName="delete"
                  (click)="removeCondition(i)" />
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="empty-triggers">
        <span class="material-symbols-rounded red">
          error
        </span>

        @if (mode == 'view') {
          <span>
            {{ 'common.alarm-rule.condition.view.empty-message' | translateSafe }}
          </span>
        } @else {
          <span>
            {{ 'common.alarm-rule.condition.edit.empty-message' | translateSafe }}
          </span>
          <app-button-icon label="common.actions.add-alarm-rule-condition"
                           [isTranslated]="true"
                           iconName="add"
                           (click)="createConditionOnClick()" />
        }
      </div>
    }
  </form>

  <app-dialog-base [class.open]="addDialogOpen"
                   iconLeft="add_diamond"
                   [buttonAction]="() => addDialogOpen = false"
                   (outSideClick)="addDialogOpen = false"
                   title="dialogs.alarm-rule.add-condition">

    <app-input-item-selection [formData]="TypeSelect"
                              (selectedOption)="onTypeSelect($event)" />
  </app-dialog-base>
}
